// Import external
import { Directive, ElementRef, Input, OnInit } from '@angular/core';

@Directive({
    selector: '[synGridCell]'
})
export class GridCellDirective implements OnInit {
    @Input() size = 1;

    constructor(private ele: ElementRef) {
    }

    ngOnInit() {
        // Check size value, must be: 1, 2, 3 or 4
        this.size = Math.round(this.size);
        if (this.size < 1) {
            this.size = 1;
        } else if (this.size > 4) {
            this.size = 4;
        }

        const classes = ' syn-grid__cell mdl-cell' +
            ' mdl-cell--4-col-phone' +
            ' mdl-cell--' + (this.size > 1 ? 8 : 4) + '-col-tablet' +
            ' mdl-cell--' + (this.size > 2 ? 12 : this.size > 1 ? 8 : 4) + '-col-desktop' +
            ' mdl-cell--' + (4 * this.size) + '-col-large';
        this.ele.nativeElement.className = this.ele.nativeElement.className + classes;
    }
}
